export default {"src":"/_next/static/media/restaurant-partner.361ac714.svg","height":325,"width":360,"blurWidth":0,"blurHeight":0};